import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { DifferenceFailure, DifferenceRequest, DifferenceReset, DifferenceSuccess } from './actions';
import { PremiumDiff } from '@models/swagger';

export const featureKey = 'difference';

export interface State {
  data: PremiumDiff[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(DifferenceFailure, (state, { error }) => ({ ...state, data: [], error, loading: false })),
    on(DifferenceRequest, state => ({ ...state, error: null, loading: true })),
    on(DifferenceSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(DifferenceReset, state => ({ ...state, data: [], error: null, loading: false }))
  )(state, action);
}
